import "./onboarding.css";
import { useContext } from "react";
import { OnboardingContext } from "../context/OnboardingContext";

export default function OnboardingLayout({ children }) {
  const { currentStep, setCurrentStep } = useContext(OnboardingContext);

  const steps = ["start", "details", "billing", "limits", "legal", "finalize"];
  const currentIndex = steps.indexOf(currentStep);

  const canGoBack = currentIndex > 0 && currentStep !== "finalize";

  function goBack() {
    const prevStep = steps[currentIndex - 1];
    setCurrentStep(prevStep);
  }

  return (
    <div className="onboarding-container">

      {/* Logo */}
      <img
        src="/logo.png"
        alt="CloudGenomics"
        className="onboarding-logo"
      />

      {/* Back button */}
      {canGoBack && (
        <button className="back-button" onClick={goBack}>
          ← Back
        </button>
      )}

      {/* Card */}
      <div className="onboarding-card slide-in">
        {children}
      </div>

      {/* Progress dots */}
      <div className="onboarding-progress">
        {steps.map((step, idx) => (
          <div
            key={step}
            className={`progress-dot ${idx === currentIndex ? "active" : ""}`}
          />
        ))}
      </div>
    </div>
  );
}